import React, { useState } from 'react';
import { Card, Button, Badge } from 'react-bootstrap';
import { FaSpinner, FaSignInAlt } from 'react-icons/fa';

const formatarCpf = (cpf) => {
  if (!cpf) return '';
  const so = String(cpf).replace(/\D/g, '').padStart(11, '0');
  return `${so.substr(0, 3)}.${so.substr(3, 3)}.${so.substr(6, 3)}-${so.substr(9, 2)}`;
};

const formatarTelefone = (tel) => {
  if (!tel) return '';
  const d = String(tel).replace(/\D/g, '');
  if (d.length === 11) {
    return `(${d.substr(0, 2)}) ${d.substr(2, 5)}-${d.substr(7, 4)}`;
  }
  if (d.length === 10) {
    return `(${d.substr(0, 2)}) ${d.substr(2, 4)}-${d.substr(6, 4)}`;
  }
  return tel;
};

const touchStyle = {
  minHeight: 44,
  fontSize: '1rem',
};

// Pendente = elegível por contrato que ainda não confirmou. O botão Check-in
// materializa a confirmação + presenças e devolve o confirmado (painel aberto).
const CardPendente = ({ pendente, confirmando, onConfirmar }) => (
  <Card className="mb-3" style={{ borderLeft: '4px solid #f59f00' }}>
    <Card.Body className="p-3">
      <div className="d-flex justify-content-between align-items-start">
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: '1.05rem' }}>
            {pendente.nome}{' '}
            <Badge variant="warning" style={{ fontSize: '0.7rem', verticalAlign: 'middle' }}>
              Pendente
            </Badge>
          </div>
          <div className="text-muted" style={{ fontSize: '0.85rem' }}>
            CPF {formatarCpf(pendente.cpf)}
            {pendente.telefone ? ` · ${formatarTelefone(pendente.telefone)}` : ''}
          </div>
          <div className="text-muted" style={{ fontSize: '0.85rem' }}>
            {pendente.tipo}
            {pendente.quadras_lotes && pendente.quadras_lotes !== '/'
              ? ` · Quadra/Lote ${pendente.quadras_lotes}`
              : ''}
          </div>
        </div>
        <Button
          variant="warning"
          onClick={() => onConfirmar(pendente.cpf)}
          disabled={confirmando}
          style={{ ...touchStyle, fontWeight: 600 }}
        >
          {confirmando ? (
            <FaSpinner className="fa-spin" />
          ) : (
            <>
              <FaSignInAlt className="mr-1" /> Check-in
            </>
          )}
        </Button>
      </div>
    </Card.Body>
  </Card>
);

export default CardPendente;
